export function getMagpieChartColors() {
  let colors = [
    '#13406C',
    '#EDAD08',
    '#5F4690',
    '#F7951C',
    '#8ba1cc',
    '#e34732',
    '#73AF48',
    '#084fd4',
    '#0F8554',
    '#994E95',
    '#CC503E',
    '#666666'
  ];
  return colors;
}

export function getMagpieDonutChartColors() {
  let colors = [
    '#13406C',
    '#8ba1cc'
  ];
  return colors;
}



// WEBPACK FOOTER //
// ./src/components/magpie-display/util/magpie-colors.js